import { render, staticRenderFns } from "./ProductsSortMobile.vue?vue&type=template&id=b490c4f2&scoped=true"
import script from "./ProductsSortMobile.vue?vue&type=script&lang=js"
export * from "./ProductsSortMobile.vue?vue&type=script&lang=js"
import style0 from "./ProductsSortMobile.vue?vue&type=style&index=0&id=b490c4f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b490c4f2",
  null
  
)

export default component.exports